import { useUIStore } from '../../../stores/uiStore';
import { useDiagramStore } from '../../../stores/diagramStore';

export function openOrgCardProperties(nodeId: string): void {
  const diagramStore = useDiagramStore.getState();
  diagramStore.setSelected(new Set([nodeId]));

  const uiStore = useUIStore.getState();
  uiStore.setPropertyPanelUserClosed(false);
  uiStore.setActivePanel('properties');
}
